if($('.admin-logged').length){
	if(!$('footer#footer').length){
        $(document).ready(function () {
            if(sessionStorage.loadedFooter) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
              customHeader()
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customHeader()
                    }
                });
            }
        })
    }
    else{
        customHeader()
    }
    function customHeader() {
    var dataMenuMap = {};

    $('.customMenuBanner > ul').each(function () {
           var $el = $(this);
        var dataMenuValue = $(this).data('menu');
        var submenuHtml = $(this).html(); // získá HTML obsahu podmenu
        var column = $el.data('column') || ''; // data-column
        var grid = $el.data('grid') || '';     // data-grid
        var left = $el.data('width-left') || '';     // data-left
        var right = $el.data('width-right') || '';     // data-right
        if (dataMenuValue && submenuHtml) {
            dataMenuMap[dataMenuValue] = {
                html: submenuHtml,
                column: column,
                grid: grid,
                dataWidthLeft: left,
                dataWidthRight: right
            };
        }
    });

    $('.menu-level-1 > li > a').each(function () {
        var hrefValue = $(this).attr('href');
        if (dataMenuMap.hasOwnProperty(hrefValue)) {
            var $li = $(this).closest('li');
            var $menuLevel2 = $li.find('.menu-level-2');

            var leftContent = $menuLevel2.html(); // původní obsah
            var rightContent = dataMenuMap[hrefValue]; // nový obsah z mapy

            // vytvoření rozděleného layoutu
             var combinedContent = `
                <li class="submenuLeft" data-width="${rightContent.dataWidthLeft}"><ul data-column="${rightContent.column}">${leftContent}</ul></li>
                <li class="submenuRight" data-width="${rightContent.dataWidthRight}"><ul data-grid="${rightContent.grid}">${rightContent.html}</ul></li>
            `;
          
            if ($menuLevel2.length > 0) {
            $li.addClass('customSubmenu')
                $menuLevel2.html(combinedContent);
            } else {
                //$li.addClass('ext').append('<ul class="menu-level-2"><li>' + combinedContent + '</li></ul>');
            }
        }
    });
}
}